import BillVariance from './BillVariance';

export interface BillProps {
  useUnit: string;
  use: number;
  tndCost: number;
  tariff: string;
  peakDemand: number;
  genCost: number;
  endDate: Date;
  startDate: Date;
  cost: number;
  demand: number;
  demandUnit: string;
  billVariances?: BillVariance;
}

export class Bill {
  useUnit: string;
  use: number;
  tndCost: number;
  tariff: string;
  peakDemand: number;
  genCost: number;
  endDate: Date;
  startDate: Date;
  cost: number;
  demand: number;
  demandUnit: string;
  billVariances?: BillVariance;

  constructor({
    useUnit,
    use,
    tndCost,
    tariff,
    peakDemand,
    genCost,
    endDate,
    startDate,
    cost,
    demand,
    demandUnit,
    billVariances
  }: BillProps) {
    this.useUnit = useUnit;
    this.use = use;
    this.tndCost = tndCost;
    this.tariff = tariff;
    this.peakDemand = peakDemand;
    this.genCost = genCost;
    this.endDate = endDate;
    this.startDate = startDate;
    this.cost = cost;
    this.demand = demand;
    this.demandUnit = demandUnit;
    this.billVariances = billVariances;
  }

  // Method to get total bill amount
  getTotalAmount(): number {
    return this.cost + this.tndCost + this.genCost;
  }

  // Method to get bill period in days
  getBillPeriodInDays(): number {
    const diffTime = Math.abs(this.endDate.getTime() - this.startDate.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  // Method to get average daily cost
  getAverageDailyCost(): number {
    return this.getTotalAmount() / this.getBillPeriodInDays();
  }
}

export default Bill;